import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaystackComponent } from './components/paystack.component';
import { PaystackEmbedComponent } from './components/paystack-embed.component';
import { PaystackDirective } from './directives/paystack.directive';
import { PaystackService } from './services/paystack.service';
import { IonicModule } from '@ionic/angular';

@NgModule({
  imports: [CommonModule,IonicModule],
  exports: [PaystackComponent,PaystackDirective, PaystackEmbedComponent],
  declarations: [PaystackComponent, PaystackDirective, PaystackEmbedComponent],
  providers: [],
})
export class PaystackModule {
  static forRoot(token: string): ModuleWithProviders<PaystackModule> {
    return {
      ngModule: PaystackModule,
      providers: [
        PaystackService
      ]
    };
  }
}
